/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterQ = createReactComponent(
  "square-rounded-letter-q",
  "IconSquareRoundedLetterQ",
  [
    [
      "path",
      {
        d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M13 15l1 1", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedLetterQ as default };
//# sourceMappingURL=IconSquareRoundedLetterQ.js.map
